// extracted by mini-css-extract-plugin
export var infoItem = "_q8-2";
export var title = "_q8-0";
export var value = "_q8-1";